import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import { DeleteOutlined, EditOutlined } from '@mui/icons-material';
import axios from 'axios';
export const PsychosocialListItem = ({ item, onEdit, onDelete, isEditDisabled }) => {
    const [isHovered, setIsHovered] = useState(false);
    const deleteItem = async () => {
        await axios.post('/api/carePlan/deletePsychosocial', {
            psychosocialId: item.id,
        });
        onDelete?.(item.id);
    };
    return (React.createElement("div", { style: {
            width: '90%',
            marginLeft: '5%',
            padding: '16px',
            marginBottom: '10px',
            borderRadius: 4,
            background: isHovered ? '#F5F5F5' : 'transparent',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer',
            transition: 'background 0.2s',
            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)'
        }, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false) },
        React.createElement("div", { style: { flex: 1 } },
            React.createElement("div", { style: { fontSize: 14, fontWeight: '500', marginBottom: 4, color: '#000000DE', fontFamily: 'Barlow' } }, item.psychosocialName),
            React.createElement("div", { style: { fontSize: 12, fontWeight: '400', color: '#00000099', fontFamily: 'Barlow' } }, item.psychosocialDescription)),
        isHovered && (React.createElement("div", { style: { display: 'flex', gap: 4 } },
            React.createElement(IconButton, { style: { height: '20px', width: '20px', color: '#0000008A' }, size: "small", disabled: isEditDisabled, onClick: (e) => {
                    e.stopPropagation();
                    onEdit?.(item.id);
                } },
                React.createElement(EditOutlined, { style: { height: '20px', width: '20px', color: '#0000008A' }, fontSize: "small" })),
            React.createElement(IconButton, { size: "small", disabled: isEditDisabled, style: { height: '20px', width: '20px', color: '#D32F2F' }, onClick: (e) => {
                    e.stopPropagation();
                    deleteItem();
                } },
                React.createElement(DeleteOutlined, { style: { height: '20px', width: '20px', color: '#D32F2F' }, fontSize: "small" }))))));
};
